import type { RouteObject } from 'react-router';
import { page } from '@/app/route-utils';

/** system: sozlamalar, audit, fon jarayonlar. */
export const workRoutes: RouteObject[] = [{ path: 'settings', ...page(() => import('./pages/SettingsPage')) }];

export const sellerRoutes: RouteObject[] = [];
